module.exports = __webpack_public_path__ + "img/view-bird.6ead3d21.png";